<mat-form-field appearance="outline" subscriptSizing="dynamic" class="concept-term-search">
  <mat-label>{{ label | translate }}</mat-label>
  <mat-icon matPrefix>search</mat-icon>
  <input
    type="text"
    matInput
    autocomplete="off"
    [formControl]="inputControl"
    [matAutocomplete]="auto"
  >
  @if (searching) {
    <mat-progress-spinner matSuffix mode="indeterminate" diameter="16"></mat-progress-spinner>
  }
  <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn" (optionSelected)="onOptionSelected($event)">
    @for (option of options; track option.id) {
      <mat-option [value]="option" class="concept-term-search__option">
        <span class="concept-term-search__name">{{ optionLabel(option) }}@if (option.has_authority) {<span class="concept-authority-right"></span>}</span>
        @if (optionAncestors(option)) {
          <span class="concept-term-search__path">{{ optionAncestors(option) }} ›</span>
        }
      </mat-option>
    }
    @if (!searching && !options.length && searchedTerm) {
      <mat-option disabled>{{ 'TRANS__IMPORT__VALUE_REVIEW__SEARCH_NO_HITS' | translate }}</mat-option>
    }
  </mat-autocomplete>
</mat-form-field>
